import React, { Component } from "react";
import { Row, Col, Card, CardBody, ButtonGroup, Button } from "reactstrap";

//Import Charts
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";
import { MONTHS } from "../Utility/Constants";

class FaultTrend extends Component {
  state = {
    series: [
      {
        name: "2020",
        type: "column",
        data: [15000, 18000, 23000, 40000, 45000, 32000, 27000, 23000, 25000, 27000, 29150, 0],
      },
      {
        name: "2019",
        type: "line",
        data: [10000, 15000, 20000, 30000, 35000, 22000, 22000, 13000, 21000, 20000, 19260, 18000],
      },
    ],
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: [0, 3],
        curve: "smooth",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20pt",
        },
      },
      dataLabels: {
        enabled: false,
      },

      legend: {
        show: false,
      },
      //colors: ['#5664d2', '#1cbb8c'],
      colors: ["#f46a6a", "#5664d2"],
      labels: MONTHS,
    },
  };
  render() {
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <div className="float-right d-none d-md-inline-block">
              <ButtonGroup className="mb-2">
                <Button size="sm" color="light" type="button">
                  Today
                </Button>
                <Button size="sm" color="light" type="button">
                  Weekly
                </Button>
                <Button size="sm" color="light" active type="button">
                  Monthly
                </Button>
              </ButtonGroup>
            </div>
            <h4 className="card-title mb-4">Fault Trend</h4>
            <div>
              {this.state.series && this.state.series?.length > 0 && (
                <div id="line-column-chart" className="apex-charts" dir="ltr">
                  <ReactApexChart options={this.state.options} series={this.state.series} type="line" height="280" />
                </div>
              )}
            </div>
          </CardBody>

          <CardBody className="border-top text-center">
            <Row>
              <Col sm={4}>
                <div className="d-inline-flex">
                  <h5 className="mr-2">₹ 29,150</h5>
                  <div className="text-success">
                    <i className="mdi mdi-menu-up font-size-14"> </i>33.92 %
                  </div>
                </div>
                <p className="text-muted text-truncate mb-0">This month</p>
              </Col>

              <Col sm={4}>
                <div className="mt-4 mt-sm-0">
                  <p className="mb-2 text-muted text-truncate">
                    <i className="mdi mdi-circle text-primary font-size-10 mr-1"></i> This Year :
                  </p>
                  <div className="d-inline-flex">
                    <h5 className="mb-0 mr-2">₹ 304,150</h5>
                    <div className="text-success">
                      <i className="mdi mdi-menu-up font-size-14"> </i>33.83%
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={4}>
                <div className="mt-4 mt-sm-0">
                  <p className="mb-2 text-muted text-truncate">
                    <i className="mdi mdi-circle text-success font-size-10 mr-1"></i> Previous Year :
                  </p>
                  <div className="d-inline-flex">
                    <h5 className="mb-0">₹ 227,260</h5>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default FaultTrend;
